import scrollLock from 'scroll-lock';
import { isElement } from '../utils';
import { gsap } from 'gsap';

let fixedEl = null;
let dummy = null;
let cardEl = null;
let fadingEl = null;

const INTRO_DURATION = 0.8;
const OUTRO_DURATION = 0.8;
const EL_DELAY = 0.2;
const EL_DURATION = 3.2;

function matchesTrigger(el) {
	const selectors = ['[data-story-card-link]'];
	return selectors.some((selector) => el.matches(selector));
}

function replaceDummy(el) {
	const classNames = ['c-story-overview-card'];
	return classNames.some((className) => el.classList.contains(className));
}

function getCard(trigger) {
	const card = trigger.closest('[data-story-card]');
	return card;
}

function getFadingEl(card) {
	if (card.classList.contains('c-story-overview-card')) {
		return card;
	} else {
		return card.querySelector('[data-thumbnail]');
	}
}

export default {
	name: 'story-overview',
	from: {
		custom: ({ current, next, trigger }) => {
			return isElement(trigger) && matchesTrigger(trigger);
		},
	},
	beforeLeave({ current, next, trigger }) {
		return new Promise((resolve) => {
			// Hide Headerbar
			if (document.body.classList.contains('has-menu-sticky')) {
				document.body.classList.remove('has-scrolled', 'has-menu-sticky');
			}

			scrollLock.disablePageScroll();

			// Create dummy and fixed overlay
			fixedEl = document.createElement('div');
			dummy = document.createElement('div');
			cardEl = getCard(trigger);
			cardEl.classList.add('is-clicked');

			fadingEl = getFadingEl(cardEl);
			const fadingElRect = fadingEl.getBoundingClientRect();

			// Set dummy width and height
			gsap.set(dummy, {
				width: fadingElRect.width,
				height: fadingElRect.height,
			});

			// Set width, height and position of cardEl element
			gsap.set(fadingEl, {
				width: fadingElRect.width,
				height: fadingElRect.height,
				top: fadingElRect.top,
				left: fadingElRect.left,
				position: 'absolute',
				pointerEvents: 'none',
				opacity: 0.9,
			});

			// Insert dummy and move triggerEl to fixed overlay
			fixedEl.classList.add('story-overview-fixed-container');
			if (cardEl.classList.contains('c-story-overview-card')) {
				fixedEl.classList.add('story-overview-fixed-container--overview');
			}

			fadingEl.parentElement.insertBefore(dummy, fadingEl);
			fixedEl.prepend(fadingEl);
			document.body.appendChild(fixedEl);

			gsap.to(fadingEl, {
				opacity: 0,
				delay: EL_DELAY,
				ease: 'sine.out',
				duration: EL_DURATION - EL_DELAY,
			});

			gsap.to(fixedEl, {
				background: 'rgba(255, 255, 255, 1)',
				ease: 'none',
				duration: INTRO_DURATION,
				onComplete: () => {
					resolve();
				},
			});
		});
	},
	afterLeave({ current, next, trigger }) {
		return new Promise((resolve) => {
			document.dispatchEvent(new CustomEvent('close-overview'));
			if (document.body.classList.contains('has-menu-sticky')) {
				document.body.classList.remove('has-scrolled', 'has-menu-sticky');
			}
			setTimeout(() => {
				resolve();
			}, (EL_DURATION - INTRO_DURATION) * 1000);
		});
	},
	enter({ current, next, trigger }) {
		return new Promise((resolve) => {
			resolve();
		});
	},
	after({ current, next, trigger }) {
		return new Promise((resolve) => {
			gsap.to(fixedEl, {
				background: 'rgba(255, 255, 255, 0)',
				ease: 'none',
				duration: OUTRO_DURATION,
				onComplete: () => {
					fadingEl.removeAttribute('style');
					if (replaceDummy(fadingEl)) {
						dummy.replaceWith(fadingEl);
					}
					fixedEl.remove();
					scrollLock.enablePageScroll();

					resolve();
				},
			});
		});
	},
};
